import Typography from '@mui/material/Typography';

interface ItemsListProps {
  stringList: string;
}

export const ItemsList: React.FC<ItemsListProps> = ({ stringList }) => {
  return (
    <>
      {stringList
        .split('ITEM:')
        .filter((t) => t !== '' && t !== ' ')
        .map((t, index) => (
          <Typography variant="body2" paddingBottom={2} key={index}>
            •{' '}
            {t
              .replaceAll('(area)', '')
              .replaceAll('(proposta)', '')
              .replaceAll('(forza)', '')
              .replaceAll('(elemento)', '')
              .replaceAll('(critica)', '')
              .trim()}
          </Typography>
        ))}
    </>
  );
};
